import React, { useEffect, useState } from 'react';
import {
  ChildrenTagScreenResponseInterface,
  DisplayDateFormat,
  FileFormatEnum,
  FileService,
  FilterNameEnumHR,
  getScreenTagsByTypeAction,
  i18n,
  JavaFormat,
  NavigationService,
  SelectTypeEnum,
  StoreStateInterface,
  TagScreenResponseInterface,
  TagScreenStateInterface,
} from '../../../../../common';
import { InboxOutlined, DeleteOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import {
  Button,
  DatePicker,
  Divider,
  Form,
  Input,
  message,
  Modal,
  notification,
  Radio,
  Select,
  TreeSelect,
  Upload,
  UploadFile,
  UploadProps,
} from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { AdminRoutes } from '../../../_router/admin.routes';
import localeHR from 'antd/es/date-picker/locale/hr_HR';
import localeEN from 'antd/es/date-picker/locale/en_GB';
import moment from 'moment';
import { RangePickerProps } from 'antd/lib/date-picker';
import {
  clearCourtAction,
  CourtStateInterface,
  createCourtAction,
  deleteCourtAction,
  getSingleCourtAction,
  updateCourtAction,
} from '../../../../../common/redux/courtEU';

const { SHOW_ALL } = TreeSelect;

const { TextArea } = Input;

const { Dragger } = Upload;

const { confirm } = Modal;

function EuCourtCrudPageComponent() {
  const location = useLocation();
  const path = location.pathname.split('/');
  const id = parseInt(path[path.length - 1]);
  const isNew = isNaN(id);

  const dispatch = useDispatch();
  const data: CourtStateInterface = useSelector((state: StoreStateInterface) => state.court);
  const tags: TagScreenStateInterface = useSelector((state: StoreStateInterface) => state.tagScreen);
  const userAuth = useSelector((state: StoreStateInterface) => state.auth);

  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [pdfUuid, setPdfUuid] = useState('');

  useEffect(() => {
    dispatch(clearCourtAction());
    dispatch(getScreenTagsByTypeAction('court_eu'));
    if (!isNew) dispatch(getSingleCourtAction(id));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!isNew) {
      if (data?.currentCourt?.attributes?.pdfUuid) {
        FileService.list(data?.currentCourt?.attributes?.pdfUuid).subscribe(
          (response: any) => {
            setFileList([{ name: response.fileName, uid: response.uuid }]);
            setPdfUuid(response.uuid);
          },
          (error: Error) => {
            console.log(error);
          }
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.currentCourt?.attributes]);

  const onFileDownload = () => {
    FileService.temp(pdfUuid).subscribe(
      (response: any) => {
        if (response.url) {
          notification['success']({ message: i18n.translate('api.downloadSuccessMessage'), duration: 2 });
          var link = document.createElement('a');
          link.href = response.url;
          link.download = 'file.pdf';
          link.dispatchEvent(new MouseEvent('click'));
        } else {
          notification['error']({ message: i18n.translate('api.errorMessage'), duration: 2 });
        }
      },
      (error: Error) => {
        notification['error']({ message: i18n.translate('api.errorMessage'), duration: 2 });
      }
    );
  };

  const beforeUpload = (file: any) => {
    if (!FileFormatEnum.ALLOWED.split(',').includes(file.type)) {
      message.error(i18n.translate('genericFileUpload.formatError', { filename: file.name }));
      return false;
    } else {
      return true;
    }
  };

  const onFileListChange = (info: any) => {
    if (!FileFormatEnum.ALLOWED.split(',').includes(info.file.type)) return;

    if (info.file.status === 'done') {
      passUuid(info.file.response[0].uuid);
      message.success(i18n.translate('genericFileUpload.uploadSuccess', { filename: info.file.name }));
    } else if (info.file.status === 'error') {
      message.error(i18n.translate('genericFileUpload.uploadFailed', { filename: info.file.name }));
    }
    setFileList([info.fileList.pop()]);
  };

  const onFileRemove = () => {
    passUuid('');
    setFileList([]);
  };

  const props: UploadProps = {
    name: 'files',
    accept: FileFormatEnum.ALLOWED,
    beforeUpload: (file: any) => beforeUpload(file),
    multiple: false,
    action: process.env.REACT_APP_FILE_UPLOAD,
    onChange: (info: any) => onFileListChange(info),
    fileList: fileList,
    showUploadList: {
      showRemoveIcon: false,
    },
  };

  const checkForNested = (tag: TagScreenResponseInterface) => {
    let nested = tag.children?.find((child) => child.nestedChildren?.length && child.nestedChildren?.length > 0);
    if (nested) return true;
    else return false;
  };

  // eslint-disable-next-line arrow-body-style
  const disabledDate: RangePickerProps['disabledDate'] = (current) => {
    // Can not select year after current year or before 1975
    return (current && current > moment().endOf('year')) || current < moment('1974').endOf('year');
  };

  const onFinishCourt = (values: any) => {
    const getTags = () => {
      let array: Array<{ id: Number; type: string }> = [];
      tags.tagScreens?.forEach((tag) => {
        const value = values[tag.filter.name as keyof any];
        if (value) {
          if (tag?.selectType === SelectTypeEnum.YEAR) {
            const childTag = tag.children?.find((child) => child.tag.name == moment(value).format('YYYY'));
            if (childTag) array.push({ id: childTag.tag.id as number, type: 'tag' });
          }
          if (tag?.selectType === SelectTypeEnum.SELECT || tag?.selectType === SelectTypeEnum.BOOLEAN) {
            const childTag = tag.children?.find((child) => child.tag.id == value);
            if (childTag) array.push({ id: childTag.tag.id as number, type: 'tag' });
          }
          if (tag?.selectType === SelectTypeEnum.MULTISELECT) {
            const value = values[tag.filter.name as keyof any];
            if (value && value.length && value.length > 0) {
              value.forEach((id: any) => {
                if (id) array.push({ id: id, type: 'tag' });
              });
            }
          }
        }
      });

      return array;
    };

    let courtData: any = {
      data: {
        type: 'court_eu',
        id: data?.currentCourt?.id,
        attributes: {
          verdictNumber: values?.verdictNumber,
          verdictName: values?.verdictName,
          verdictTitle: values?.verdictTitle,
          textContent: values?.textContent,
          comment: values?.comment,
          verdictDate: values?.verdictDate ? moment(values?.verdictDate).format(JavaFormat) : null,
          procedureType: values?.procedureType,
          directiveNumber: values?.directiveNumber,
          directiveArticle: values?.directiveArticle,
          engLink: values?.engLink,
          hrLink: values?.hrLink,
          pdfUuid: pdfUuid,
        },
        relationships: {
          tags: {
            data: getTags(),
          },
        },
      },
    };
    isNew ? dispatch(createCourtAction(courtData)) : dispatch(updateCourtAction(courtData));
    window.scrollTo({ top: 0, behavior: 'smooth' });

    setTimeout(() => {
      NavigationService.navigate(AdminRoutes.EU_COURT_DECLARATIONS.fullPath);
    }, 1000);
  };

  const onFinishCourtFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo);
  };

  const setTreeData = (children: Array<ChildrenTagScreenResponseInterface>) => {
    let values = children.map((child) => ({
      title: child.tag.name,
      value: child.tag.id,
      key: child.tag.id,
      children: child.nestedChildren?.map((nestedChild) => ({
        title: nestedChild.tag.name,
        value: nestedChild.tag.id,
        key: nestedChild.tag.id,
        children: nestedChild.nestedChildren?.map((nestedLvl2Child) => ({
          title: nestedLvl2Child.tag.name,
          value: nestedLvl2Child.tag.id,
          key: nestedLvl2Child.tag.id,
        })),
      })),
    }));
    return values;
  };
  
  const getDisplayConditions = () => {
    if (isNew) {
      return tags?.tagScreens && tags?.tagScreens?.length > 0;
    } else {
      return tags?.tagScreens && tags?.tagScreens?.length > 0 && data?.currentCourt;
    }
  };

  const getFilter = (field: string) => {
    let filter;
    let tag = tags?.tagScreens?.find((tag) => tag.filter.name == field);
    if (tag) {
      let array: number[] = [];
      data?.currentCourt?.attributes?.tagIds?.forEach((id) => {
        tag?.children?.forEach((child) => {
          if (id === child.tag.id) {
            if (tag?.selectType === SelectTypeEnum.YEAR) {
              filter = moment(child.tag.name);
            }
            if (tag?.selectType === SelectTypeEnum.SELECT || tag?.selectType === SelectTypeEnum.BOOLEAN) {
              filter = child.tag.id;
            }
            if (tag?.selectType === SelectTypeEnum.MULTISELECT) {
              array.push(child.tag.id);
            }
          }
        });
      });

      if (tag?.selectType === SelectTypeEnum.MULTISELECT) filter = array;
    }
    return filter;
  };

  const loadInitialValues = () => {
    let values: any = {
      verdictNumber: data?.currentCourt?.attributes?.verdictNumber,
      verdictName: data?.currentCourt?.attributes?.verdictName,
      verdictTitle: data?.currentCourt?.attributes?.verdictTitle,
      textContent: data?.currentCourt?.attributes?.textContent,
      comment: data?.currentCourt?.attributes?.comment,
      verdictDate: data?.currentCourt?.attributes?.verdictDate ? moment(data?.currentCourt?.attributes?.verdictDate) : null,
      procedureType: data?.currentCourt?.attributes?.procedureType,
      directiveNumber: data?.currentCourt?.attributes?.directiveNumber,
      directiveArticle: data?.currentCourt?.attributes?.directiveArticle,
      engLink: data?.currentCourt?.attributes?.engLink,
      hrLink: data?.currentCourt?.attributes?.hrLink,
    };

    tags.tagScreens?.forEach((tag) => {
      values[tag.filter.name as keyof any] = getFilter(tag.filter.name);
    });

    return values;
  };

  const loadDefaultValues = () => {
    let values: any = {};

    tags.tagScreens?.forEach((tag) => {
      if (tag.filter.name == FilterNameEnumHR.ZJN) {
        values[tag.filter.name as keyof any] = [tag.children?.length ? tag.children[0].tag.id : []];
      }
    });

    return values;
  };

  const clearCurrentCourt = () => {
    dispatch(clearCourtAction());
  };

  const passUuid = (uuid: string) => {
    setPdfUuid(uuid);
  };

  const showConfirm = () => {
    confirm({
      title: i18n.t('euCourt.confirmDelete'),
      icon: <ExclamationCircleOutlined />,
      content: i18n.t('common.cantUndo'),
      okText: i18n.t('genericButtons.yes'),
      cancelText: i18n.t('genericButtons.cancel'),
      onOk() {
        dispatch(deleteCourtAction(id));
        window.scrollTo({ top: 0, behavior: 'smooth' });

        setTimeout(() => {
          NavigationService.navigate(AdminRoutes.EU_COURT_DECLARATIONS.fullPath);
        }, 1000);
      },
    });
  };

  const returnComponent = (tag: TagScreenResponseInterface) => {
    let component = null;
    if (tag.selectType == SelectTypeEnum.YEAR) {
      component = (
        <DatePicker
          picker="year"
          disabledDate={disabledDate}
          locale={userAuth.lang == 'hr' ? localeHR : localeEN}
          format={'YYYY.'}
        />
      );
    }

    if (tag.selectType == SelectTypeEnum.BOOLEAN) {
      component = (
        <Radio.Group>
          <Radio.Button value={tag.children?.length ? tag.children[0].tag.id : 0}>
            {tag.children?.length ? tag.children[0].tag.name : ''}
          </Radio.Button>
          <Radio.Button value={tag.children?.length ? tag.children[1].tag.id : 1}>
            {tag.children?.length ? tag.children[1].tag.name : ''}
          </Radio.Button>
        </Radio.Group>
      );
    }

    if (tag.selectType == SelectTypeEnum.SELECT || tag.selectType == SelectTypeEnum.MULTISELECT) {
      if (checkForNested(tag)) {
        component = (
          <TreeSelect
            treeData={setTreeData(tag.children as Array<ChildrenTagScreenResponseInterface>)}
            treeCheckable
            showCheckedStrategy={SHOW_ALL}
            maxTagCount="responsive"
            placeholder={i18n.t('genericFormMsg.placeholders.select')}
          />
        );
      } else {
        component = (
          <Select
            mode={tag.selectType == SelectTypeEnum.MULTISELECT ? 'multiple' : undefined}
            maxTagCount={tag.selectType == SelectTypeEnum.MULTISELECT ? 'responsive' : undefined}
            allowClear
          >
            {tag.children?.length &&
              tag.children.map((child) => (
                <Select.Option key={child.tag.name} value={child.tag.id}>
                  {child.tag.name}
                </Select.Option>
              ))}
          </Select>
        );
      }
    }

    return component;
  };

  return (
    <div className="euCourtCrud w100-h100">
      {getDisplayConditions() && (
        <Form
          layout="vertical"
          name="euCourt"
          size="large"
          scrollToFirstError
          initialValues={data?.currentCourt && !isNew ? loadInitialValues() : loadDefaultValues()}
          onFinish={onFinishCourt}
          onFinishFailed={onFinishCourtFailed}
          autoComplete="off"
          requiredMark={false}
        >
          <div className="euCourtCrud__admin">
            <div className="title">{i18n.translate(isNew ? 'euCourt.crudTitleAdd' : 'euCourt.crudTitleUpdate')}</div>
            <div className="buttons">
              <Link to={AdminRoutes.EU_COURT_DECLARATIONS.fullPath} key={AdminRoutes.EU_COURT_DECLARATIONS.path}>
                <Button
                  onClick={clearCurrentCourt}
                  className="button"
                  size="large"
                  style={{ fontSize: 16, fontWeight: 700, borderRadius: 0, minWidth: 193, marginRight: 16 }}
                >
                  {i18n.translate('genericButtons.cancel')}
                </Button>
              </Link>
              <Button
                className="button"
                htmlType="submit"
                type="primary"
                size="large"
                style={{ fontSize: 16, fontWeight: 700, borderRadius: 0, minWidth: 193 }}
              >
                {i18n.translate('genericButtons.save')}
              </Button>
            </div>
          </div>
          <Divider />
          <div className="euCourtCrud__form">
            <div className="subtitle">
              <span className="text">{i18n.translate('euCourt.form.sections.info')}</span>
            </div>

            <Form.Item
              label={<span className="text-bold">{i18n.translate(`euCourt.form.fields.verdictNumber`)}</span>}
              name="verdictNumber"
              rules={[{ required: true, message: i18n.translate(`genericFormMsg.required`) }]}
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 12 }}
            >
              <Input style={{ borderRadius: 0 }} />
            </Form.Item>

            <Form.Item
              label={<span className="text-bold">{i18n.translate(`euCourt.form.fields.verdictName`)}</span>}
              name="verdictName"
              rules={[{ required: true, message: i18n.translate(`genericFormMsg.required`) }]}
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 12 }}
            >
              <TextArea style={{ borderRadius: 0 }} autoSize={{ minRows: 2 }} />
            </Form.Item>

            <Form.Item
              label={<span className="text-bold">{i18n.translate(`euCourt.form.fields.verdictTitle`)}</span>}
              name="verdictTitle"
              rules={[{ required: true, message: i18n.translate(`genericFormMsg.required`) }]}
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 12 }}
            >
              <TextArea style={{ borderRadius: 0 }} autoSize={{ minRows: 4 }} />
            </Form.Item>

            <Form.Item
              label={<span className="text-bold">{i18n.translate(`euCourt.form.fields.textContent`)}</span>}
              name="textContent"
              rules={[{ required: true, message: i18n.translate(`genericFormMsg.required`) }]}
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 12 }}
            >
              <TextArea style={{ borderRadius: 0 }} autoSize={{ minRows: 4 }} />
            </Form.Item>

            <Form.Item
              label={<span className="text-bold">{i18n.translate(`euCourt.form.fields.comment`)}</span>}
              name="comment"
              //rules={[{ required: true, message: i18n.translate(`genericFormMsg.required`) }]}
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 12 }}
            >
              <TextArea style={{ borderRadius: 0 }} autoSize={{ minRows: 4 }} />
            </Form.Item>

            <Form.Item
              label={<span className="text-bold">{i18n.translate(`euCourt.form.fields.verdictDate`)}</span>}
              name="verdictDate"
            >
              {/** DISABLED DATE ISPOD AKO TREBA */}
              <DatePicker
                style={{ borderRadius: 0 }}
                locale={userAuth.lang == 'hr' ? localeHR : localeEN}
                format={DisplayDateFormat}
              />
            </Form.Item>

            <Form.Item
              label={<span className="text-bold">{i18n.translate(`euCourt.form.fields.procedureType`)}</span>}
              name="procedureType"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 12 }}
            >
              <Input style={{ borderRadius: 0 }} />
            </Form.Item>

            <Form.Item
              label={<span className="text-bold">{i18n.translate(`euCourt.form.fields.directiveNumber`)}</span>}
              name="directiveNumber"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 12 }}
            >
              <Input style={{ borderRadius: 0 }} />
            </Form.Item>

            <Form.Item
              label={<span className="text-bold">{i18n.translate(`euCourt.form.fields.directiveArticle`)}</span>}
              name="directiveArticle"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 12 }}
            >
              <Input style={{ borderRadius: 0 }} />
            </Form.Item>

            <div className="subtitle">
              <span className="text">{i18n.translate('euCourt.form.sections.filters')}</span>
            </div>

            {/** OVDJE ISPOD SVI FILTERI TREBAJU BITI GENERIČKI */}

            {tags.tagScreens?.map((tag) => (
              <Form.Item
                label={<span className="text-bold">{`${tag.filter.name}`}</span>}
                name={tag.filter.name}
                key={tag.filter.name}
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 8 }}
              >
                {returnComponent(tag)}
              </Form.Item>
            ))}

            {/** GENERIC FILTERI END */}

            <div className="subtitle">
              <span className="text">{i18n.translate('euCourt.form.sections.upload')}</span>
            </div>

            <Form.Item
              label={<span className="text-bold">{i18n.translate(`euCourt.form.fields.pdf`)}</span>}
              name="pdf"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 10 }}
            >
              <Dragger {...props}>
                <p className="ant-upload-drag-icon">
                  <InboxOutlined />
                </p>
                <p className="ant-upload-text">{i18n.translate(`euCourt.form.upload.text`)}</p>
              </Dragger>
            </Form.Item>

            {fileList && fileList.length > 0 && (
              <div>
                <Button type="link" style={{ color: 'red', marginBottom: 8 }} onClick={onFileRemove}>
                  {i18n.translate(`genericButtons.delete`)}
                </Button>
                <Button type="link" style={{ marginLeft: 8, marginBottom: 8 }} onClick={onFileDownload}>
                  {i18n.translate(`genericButtons.download`)}
                </Button>
              </div>
            )}

            <Form.Item
              label={
                <span className="text-bold">{i18n.translate(`euCourt.form.fields.hrLink`)}</span>
              }
              name="hrLink"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 12 }}
            >
              <Input style={{ borderRadius: 0 }} />
            </Form.Item>

            <Form.Item
              label={
                <span className="text-bold">{i18n.translate(`euCourt.form.fields.engLink`)}</span>
              }
              name="engLink"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 12 }}
            >
              <Input style={{ borderRadius: 0 }} />
            </Form.Item>
          </div>
          <div className="euCourtCrud__bottomButtons">
            <div>
              {!isNew && (
                <Button
                  danger
                  onClick={showConfirm}
                  className="button"
                  size="large"
                  icon={<DeleteOutlined />}
                  style={{ fontSize: 16, fontWeight: 700, borderRadius: 0, minWidth: 193 }}
                >
                  {i18n.translate('genericButtons.delete')}
                </Button>
              )}
            </div>
            <div>
              <Link to={AdminRoutes.EU_COURT_DECLARATIONS.fullPath} key={AdminRoutes.EU_COURT_DECLARATIONS.path}>
                <Button
                  onClick={clearCurrentCourt}
                  className="button"
                  size="large"
                  style={{ fontSize: 16, fontWeight: 700, borderRadius: 0, minWidth: 193, marginRight: 16 }}
                >
                  {i18n.translate('genericButtons.cancel')}
                </Button>
              </Link>
              <Button
                className="button"
                htmlType="submit"
                type="primary"
                size="large"
                style={{ fontSize: 16, fontWeight: 700, borderRadius: 0, minWidth: 193 }}
              >
                {i18n.translate('genericButtons.save')}
              </Button>
            </div>
          </div>
        </Form>
      )}
    </div>
  );
}

export default EuCourtCrudPageComponent;
